import moment from 'moment'
import {
  BOOKING_BOOKED_WITHOUT_PAYMENT,
  BOOKING_CONFIRMED,
  BOOKING_CONFIRMED_WITHOUT_PAYMENT,
  BOOKING_EXPIRED,
  BOOKING_PAID,
  BOOKING_PAYMENT_INITIATED,
  BOOKING_RESERVED,
  TYPE_BOOKING_REQUEST,
  US_COUNTRY,
} from "@base/configs";

export const encodedObjectUrl = language => {
  return Object.entries(language)
    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
    .join('&')
}

export const saveFile = (base64, filename, filetype) => {
  const a = document.createElement('a')
  a.href = 'data:' + filetype + ';base64,' + base64
  a.download = filename
  document.body.appendChild(a)
  a.click()
  setTimeout(() => {
    document.body.removeChild(a)
  }, 0)
}


export const isEmbedded = () => window.self !== window.top

// A scanner types the code on the OS keyboard layout, so the dash may arrive as + or vanish.
export const normaliseSoloGiftCardCode = (raw) => {
  const code = (raw || '').trim().toUpperCase()
  const match = code.match(/^(GC[A-Z]*)[^A-Z0-9]?(\d{8})$/)
  return match ? `${match[1]}-${match[2]}` : code
}

export const localizedStringToNumber = (value) => {
  return parseFloat(value.replace(/[.,](?=\d*[.,])/g,''))
}

export const floatToLocalizedString = (value, marketCountry = null) => {
  // eslint-disable-next-line no-undef
  const locale = marketCountry === US_COUNTRY ? 'en-US' : LANGUAGE_CODE
  return Number(value).toLocaleString(
    locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}
  )
}

export const canContinueCreateBookingRequest = (bookingRequestObj) => {
  return bookingRequestObj.kind === TYPE_BOOKING_REQUEST
    && [BOOKING_RESERVED, BOOKING_PAYMENT_INITIATED].includes(bookingRequestObj.status)
    && !bookingRequestObj.parentBookingRequest
    && !bookingRequestObj.isPaymentRequest
    && moment().isSameOrBefore(moment.parseZone(bookingRequestObj.created).add(15, 'minutes'))
}

export const canExtendBookingRequest = (bookingRequestObj) => {
  return bookingRequestObj.kind === TYPE_BOOKING_REQUEST
    && [BOOKING_PAID, BOOKING_CONFIRMED, BOOKING_BOOKED_WITHOUT_PAYMENT, BOOKING_CONFIRMED_WITHOUT_PAYMENT].includes(bookingRequestObj.status)
    && !bookingRequestObj.isPaymentRequest
    && (
      !bookingRequestObj.childrenIds.length || (
        bookingRequestObj.childrenIds.length
        && bookingRequestObj.childrenStatuses.every(status => status === BOOKING_EXPIRED)
      )
    )
    && moment().isSameOrBefore(moment.parseZone(bookingRequestObj.dateEnd).add(3, 'days'))
}

export const canContinueBookingRequestExtension = (bookingRequestObj) => {
  return bookingRequestObj.kind === TYPE_BOOKING_REQUEST
    && [BOOKING_RESERVED, BOOKING_PAYMENT_INITIATED].includes(bookingRequestObj.status)
    && bookingRequestObj.parentBookingRequest
    && !bookingRequestObj.isPaymentRequest
    && moment().isSameOrBefore(moment.parseZone(bookingRequestObj.dateEnd).add(3, 'days'))
}

export const canFinalizeBookingPaymentRequest = (bookingRequestObj) => {
  return bookingRequestObj.kind === TYPE_BOOKING_REQUEST
    && bookingRequestObj.status === BOOKING_RESERVED
    && bookingRequestObj.isPaymentRequest
}

export const canContinueFinalizeBookingPaymentRequest = (bookingRequestObj) => {
  return bookingRequestObj.kind === TYPE_BOOKING_REQUEST
    && bookingRequestObj.status === BOOKING_PAYMENT_INITIATED
    && bookingRequestObj.isPaymentRequest
}